import NonEditablePaymentCodes from './non-editable-payment-codes-component';
import NonEditablePaymentCodesService from './non-editable-payment-codes-service';

const MODULE_NAME = 'Trip.payment-codes.non-editable';
const module = angular.module(MODULE_NAME, [])
    .directive(NonEditablePaymentCodes.DIRECTIVE_NAME, NonEditablePaymentCodes)
    .service(NonEditablePaymentCodesService.SERVICE_NAME, NonEditablePaymentCodesService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/non-editable-payment-codes/non-editable-payment-codes-module.js